exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".role-button[data-v-310dc450]{position:relative;cursor:pointer}.role-button[data-v-310dc450],img[data-v-310dc450]{display:inline-block;width:200px}img[data-v-310dc450]{height:200px;object-fit:contain}figcaption[data-v-310dc450]{margin-top:10px;font-weight:600}", ""]);

